import { pdfjs } from 'react-pdf'

// react-pdf 9 uses pdfjs-dist 4.x, whose worker is ESM (.mjs). Under webpack 5
// the worker is emitted as an asset via new URL(..., import.meta.url). Pinning
// pdfjs-dist to the exact version react-pdf bundles keeps the worker and API
// versions in sync.
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString()
